// Блок перелинковки («Полезные статьи», «Смотрите также»). Данные — в
// `mode.relatedLinks`:
//
//   relatedLinks: [ { to: '/blog/…', text: 'анкор' }, … ]
//   relatedLinksTitle: 'Полезные статьи'   // необязательно
//
// Ссылки — настоящие <a href> через react-router Link, не onClick: иначе для
// робота внутренней перелинковки не существует, а справка Яндекса прямо просит
// «делайте ссылки на другие разделы сайта текстовыми».

import { Link } from "react-router-dom";

import Plate from "components/UI/Plate/Plate";

import "./SeoContent.scss";

export default function SeoRelatedLinks({ title = "Полезные статьи", links }) {
  if (!Array.isArray(links) || !links.length) return null;

  return (
    <section className="seo-content__section seo-content__related">
      <h2 className="seo-content__title">{title}</h2>
      <Plate className="seo-content__plate">
        <ul className="seo-content__list">
          {links.map((link, i) => (
            <li key={i}>
              {link.external ? (
                <a href={link.to} target="_blank" rel="noopener noreferrer">
                  {link.text}
                </a>
              ) : (
                <Link to={link.to}>{link.text}</Link>
              )}
            </li>
          ))}
        </ul>
      </Plate>
    </section>
  );
}
